module.exports = __webpack_public_path__ + "img/guide_2_1.bcd20d41.svg";